import { ArrowUpRight, CircleHelp } from "lucide-react";
import { cn } from "@/lib/utils";
import type { GenieSupportLinkProps } from "@/types/voice/conversation-follow-up";

export const GenieSupportLink = ({ href, compact = false }: GenieSupportLinkProps) => (
  <a href={href} target="_blank" rel="noopener noreferrer"
    className={cn(
      "inline-flex min-h-[44px] shrink-0 items-center gap-1 rounded-xl text-sm font-medium text-gray-600 transition-colors hover:bg-white hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-genie-primary",
      compact ? "min-w-[44px] justify-center" : "px-3",
    )}
    title={compact ? "Support page" : undefined}
    aria-label="Support page (opens in a new tab)">
    {compact ? (
      <CircleHelp className="h-[18px] w-[18px]" aria-hidden="true" />
    ) : (
      <>Support page <ArrowUpRight className="h-4 w-4" /></>
    )}
  </a>
);
